import type { Release } from "@packages/commons";
import { SettingsProvider } from "@/pages/admin/Settings/SettingsContext";
import EventConnectorsTab from "@/pages/admin/Settings/tabs/EventConnectorsTab";
import { useQueryClient } from "react-query";

interface EventConnectorDialogProps {
  eventType?: string;
  eventTypes?: string[];
  connectorId?: string;
  release?: Release;
  onClose: () => void;
}

export const EventConnectorDialog = ({ eventType, eventTypes, connectorId, release, onClose }: EventConnectorDialogProps) => {
  const queryClient = useQueryClient();
  const close = () => {
    void queryClient.invalidateQueries("event-detail-connectors");
    onClose();
  };

  return (
    <SettingsProvider>
      <EventConnectorsTab
        initialEventId={eventType}
        initialEventIds={eventTypes}
        initialConnectorId={connectorId}
        release={release}
        dialogOnly
        onClose={close}
      />
    </SettingsProvider>
  );
};
